export default defineAppConfig({
  ui: {
    primary: 'vblue',
    gray: 'neutral',
    page: {
      header: {
        wrapper: 'border-0', // Remove the underline from page headers
        // title: 'font-header font-black tracking-tight uppercase',
      },

    },
    formGroup: {
      help: 'mt-1', // Tighten the space between form groups and their help text
    },
    dashboard: {
      toolbar: {
        wrapper: 'min-h-[3.5rem]', // Remove the border from the dashboard toolbar
      },
      navbar: {
        // title: 'font-header font-black tracking-tight uppercase'
      }
    },
    pricing: {
      card: {
        // title: 'font-header font-bold tracking-tight uppercase'
      }
    },
    table: {
      th: {
        // font: 'font-header font-bold tracking-tight uppercase'
      }
    },
    popover: {
      width: 'max-w-[300px]',
      container: 'font-normal text-black dark:text-white text-xs',
      base: 'p-3'
    }
  },
});
